<script>

export default {
    props: {
        label: {type: String, required: true},
        items: {type: Array, required: true}, /*
            * sample menu item:
            * {
            *   label: 'Foobar'
            *   fn: foobarAction
            * }
            */

    },
    data() {
        return {
            showMenu: false
        }
    },

    methods: {
        callMenu: function(fn) {
            this.showMenu = false
            fn()
        }
    }
}
</script>

<template>
    <li class="nav-item dropdown">
        <a href="#" class="btn btn-secondary btn-block btn-sm-lg navbar-btn dropdown-toggle me-1 mb-1"
         id="navbarDropdownMenuLink" @click.prevent="showMenu=!showMenu">
            {{ label }}
        </a>
        <div v-if="showMenu" class="dropdown-menu">
            <template v-for="menu in items">
                <a v-if="menu.label" class="dropdown-item" href="#" @click.prevent="callMenu(menu.fn)">
                    {{ menu.label }}
                </a>
                <div v-else class="dropdown-divider"></div>
            </template>
        </div>
    </li>
</template>

<style scoped>

.dropdown-item, .nav-link { 
    text-decoration: none
}

@media screen and (min-width: 960px) {
    .btn-block {
        display: inline-block;
        width: auto;
    }

    .btn-sm-lg {
        padding: 0.25rem 0.5rem;
        font-size: 0.8rem;
        line-height: 1.5;
        border-radius: 0rem;
    }
}
</style>